/**
 * Created by mariushirjanu on 14/12/2020.
 */
import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { IObject } from '@type_definitions/datatypes';
import { util } from '../../util';
import { distinctUntilChanged } from 'rxjs/operators';
import { ReportFiltersUtil } from '../../report/report-filters-util.service';
import { TranslationService } from '../../translation/translation.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';
import { ReportParameterShortCode } from '@app/main/report/report-state.util';

/**
 * This allows to display a link in 3 different ways:
 *  - normal link with href attribute
 *  - link with uiSref attribute (UI router)
 *  - link with onClick event
 *
 *  Label and href can be dynamically updated.
 *  Additionally, the link can be converted to a button by providing a css class that starts with 'btn-' (e.g. linkClass: 'btn-primary')
 */

@Component({
  selector: 'formly-field-link',
  template: `
    <ng-template #content><i *ngIf="to.icon" class="fa {{to.icon}}">&nbsp;</i>{{ label }}</ng-template>
    
    <a *ngIf="href && !to.onClick" [attr.href]="href" target="{{ to.target }}" [class]="linkClass"><ng-container [ngTemplateOutlet]="content"></ng-container></a>
    <a *ngIf="!href && !to.onClick" [uiSref]="to.uiSref" [uiParams]="uiParams" [class]="linkClass" target="{{ to.target }}"><ng-container [ngTemplateOutlet]="content"></ng-container></a>
    <a *ngIf="!href && to.onClick" href (click)="onClick($event)" [class]="linkClass" [busyButton]="to.busy" [class.disabled]="to.disabled"><ng-container [ngTemplateOutlet]="content"></ng-container></a>
  `
})
export class FormlyFieldLinkComponent extends ExtraFieldType implements OnInit {
  public uiParams:IObject;
  public href:string;
  public label:string;
  public linkClass:string;

  constructor(
    private reportFiltersUtil:ReportFiltersUtil,
    private translationService:TranslationService,
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.href = this.to.href;
    this.label = this.translationService.instant(this.to.label);

    if (this.to.uiParams) {
      this.uiParams = util.deepClone(this.to.uiParams);

      if (this.uiParams?.[ReportParameterShortCode.FILTERS]) {
        this.uiParams[ReportParameterShortCode.FILTERS] = this.reportFiltersUtil.filtersToParam(this.to.uiParams?.[ReportParameterShortCode.FILTERS], undefined, { applyNullValues: true });
      }
      if (!this.uiParams.menu) { // by default do not add query param menu
        this.uiParams.menu = undefined;
      }
    }

    this.setLinkClasses(this.label);

    // register listener
    this.listen();
  }

  protected listen():void {
    // watch for url updates
    if (this.to.urlObserver) {
      this.to.urlObserver
        .pipe(
          distinctUntilChanged()
        )
        .subscribe((url:string) => {
          if (url) {
            this.href = url;
          }
        });
    }

    // watch for label updates
    if (this.to.labelObserver) {
      this.to.labelObserver
        .pipe(
          distinctUntilChanged()
        )
        .subscribe((label:string) => {
          if (label) {
            this.label = this.translationService.instant(this.to.label);
            this.setLinkClasses(this.label);
          }
        });
    }
  }

  public onClick(event:Event):void {
    event.preventDefault();
    this.to.onClick();
  }

  private getLinkClasses():string {
    const BUTTON_REGEXP:RegExp = /btn-[\w]*/;

    // make the link a button when contains a linkClass that starts with 'btn-'
    if (BUTTON_REGEXP.test(this.to.linkClass)) {
      return `btn ${this.to.linkClass}`;
    } else {
      return this.to.linkClass;
    }
  }

  private setLinkClasses(label:string):void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.LINK, undefined, label);
    this.linkClass = `${this.getLinkClasses()} ${this.classNames}`;
  }
}